import { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

function TechStack() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <p className="text-gray-600 mb-4">
        This is SellAbroad.io, a comprehensive e-commerce enablement platform designed to help businesses expand into the MENAP (Middle East, North Africa, and Pakistan) region. The platform serves as a unified dashboard for businesses to manage their entire MENAP e-commerce operations, from market entry to day-to-day operations and growth.
      </p>

      <button
        onClick={() => setShowModal(true)}
        className="text-[#0049ac] hover:text-[#0049ac]/90"
      >
        View Tech Stack →
      </button>

      {showModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <div className="relative w-full max-w-7xl rounded-xl bg-white p-6 shadow-xl">
              <button
                onClick={() => setShowModal(false)}
                className="absolute right-4 top-4 text-[#0049ac] hover:text-[#0049ac]/90"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>

              <div className="mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Core Features</h3>
                <div className="grid grid-cols-3 gap-8">
                  <div>
                    <h4 className="text-lg font-semibold mb-4">Onboarding Flow</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>Market Selection: Interactive world map for selecting target markets</li>
                      <li>Product Information: Compliance and certification checks</li>
                      <li>Channel Connections: Integration with marketplaces, marketing platforms, and sales channels</li>
                      <li>Demand Forecasting: Market analysis and sales predictions</li>
                      <li>Document Management: Business verification and compliance documentation</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-4">Operations Management</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>Inventory Management: Stock tracking and allocation across marketplaces</li>
                      <li>Order Management: Centralized order processing and fulfillment</li>
                      <li>Logistics Dashboard: 3PL integration and shipment tracking</li>
                      <li>Analytics: Performance metrics and reporting</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-4">Marketing & Strategy</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>Marketing Dashboard: Campaign management and performance tracking</li>
                      <li>Business DNA: Brand identity and market positioning tool</li>
                      <li>Content Generation: AI-powered marketing content creation</li>
                      <li>Compliance AI: Regulatory compliance assistant</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Technical Architecture</h3>
                <div className="grid grid-cols-3 gap-8">
                  <div>
                    <h4 className="text-lg font-semibold mb-4">Frontend</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>React with Vite</li>
                      <li>Styling: Tailwind CSS</li>
                      <li>State Management: React Context</li>
                      <li>Maps: react-simple-maps</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-4">Backend</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>Authentication: Firebase, most</li>
                      <li>Database: MongoDB</li>
                      <li>API Integration: RESTful services</li>
                      <li>AI Integration: OpenAI for content generation</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-4">Architecture Principles</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>Separate components for each major feature</li>
                      <li>Reusable UI components</li>
                      <li>Clear separation of concerns</li>
                      <li>Responsive design</li>
                      <li>Comprehensive error handling</li>
                      <li>Type safety with TypeScript</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Sales Channel Integration</h3>
                <div className="grid grid-cols-3 gap-8">
                  <div>
                    <h4 className="text-lg font-semibold mb-4">Marketplace Connections</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>Amazon</li>
                      <li>Noon</li>
                      <li>Jumia</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-4">DTC Website Integration</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>Shopify</li>
                      <li>WooCommerce</li>
                      <li>Magento</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-4">Marketing Platform Integration</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>Meta Ads</li>
                      <li>Google Ads</li>
                      <li>Klaviyo</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TechStack;